const getFormattedPostDate = postDate => {
  if (postDate) {
    return `${postDate.Y}-${postDate.m}-${postDate.d}`;
  }
  return '';
};

const articleJSONLD = data => `{
  "@context": "http://schema.org", 
  "@type": "Article",
  "headline": "${data.headline}",
  "alternativeHeadline": "${data.subline}",
  "image": "${data.seo.og.image ? `https://futurium.de${data.seo.og.image}` : ''}",
  "author": "${data.articleAuthor.map(author => author.fullName)}", 
  "editor": "${data.articleAuthor.map(author => author.fullName)}", 
  "genre": "${data.pageTags.map(tag => tag.title)}", 
  "keywords": "${data.pageTags.map(tag => tag.title)}", 
  "publisher": {
    "@type": "Organization",
    "name": "Futurium",
    "logo": "https://futurium.de/futurium-logo.png"
  },
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "${data.seo.links.canonical}"
  },
  "url": "https://futurium.de/",
  "datePublished": "${getFormattedPostDate(data.postDate)}",
  "dateModified": "${getFormattedPostDate(data.postDate)}",
  "description": "${data.introCopy?.replace(/<(?:.|\n)*?>/gm, '')}"
}`;

export default articleJSONLD;
